
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.143 0L15.5 4.167h-2.633L11.065 0h2.078zM9.81 0l1.802 4.167H4.388L6.19 0h3.62zM2.857 0h2.078L3.133 4.167H.5L2.857 0zM.5 5h2.622l3.204 6.555c.039.08-.07.153-.13.086L.5 5zm3.86 0h7.28l-3.567 8.287c-.026.062-.117.062-.143 0L4.36 5zm5.314 6.555L12.878 5H15.5l-5.695 6.638c-.06.07-.17-.003-.13-.083z","fill":"#00DCF7"}})])
          )
        }
      }
    